"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const formik_1 = require("formik");
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const components_common_checkbox_1 = require("@hotelplan/components.common.checkbox");
const components_common_counter_1 = require("@hotelplan/components.common.counter");
const components_common_text_input_1 = require("@hotelplan/components.common.text-input");
const libs_countries_1 = require("@hotelplan/libs.countries");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
const fdr_catalogs_order_form_styles_1 = require("./fdr-catalogs-order-form.styles");
const fdr_catalogs_order_form_types_1 = require("./fdr-catalogs-order-form.types");
const fdr_catalogs_order_form_validation_1 = require("./fdr-catalogs-order-form.validation");
const fdr_catalogs_order_recaptcha_1 = __importDefault(require("./fdr-catalogs-order-recaptcha"));
const recaptchaValidation = (_a = fdr_catalogs_order_form_validation_1.OrderCatalogsFormValidationSchema.fields) === null || _a === void 0 ? void 0 : _a.recaptchaToken;
const FdrCatalogsOrderForm = ({ ids, onSubmit, isCaptchaEnabled, isCounterEnabled, genderInputType, submitButtonIcon, showInlinesErrorMessages, isDropdownEmptyValueEnabled, }) => {
    var _a;
    const [t] = (0, next_i18next_1.useTranslation)('forms');
    const withEmptyDropdownOption = (0, react_1.useCallback)((options) => {
        if (isDropdownEmptyValueEnabled) {
            options.unshift({
                value: '',
                label: t(`forms:dropdown.pleaseSelect`),
            });
        }
        return options;
    }, [t, isDropdownEmptyValueEnabled]);
    const genderRadioOptions = (0, react_1.useMemo)(() => [
        { value: supergraph_api_1.FdrSalutation.Mr, content: t('forms:gender.options.male') },
        { value: supergraph_api_1.FdrSalutation.Ms, content: t('forms:gender.options.female') },
    ], [t]);
    const genderSelectOptions = (0, react_1.useMemo)(() => {
        return withEmptyDropdownOption(genderRadioOptions.map(({ value, content }) => ({
            value,
            label: content,
        })));
    }, [withEmptyDropdownOption, genderRadioOptions]);
    const countryOptions = (0, react_1.useMemo)(() => {
        return withEmptyDropdownOption([
            { value: libs_countries_1.CountryOption.CH, label: t('forms:country.options.ch') },
            { value: libs_countries_1.CountryOption.LI, label: t('forms:country.options.li') },
        ]);
    }, [withEmptyDropdownOption]);
    if (!isCaptchaEnabled) {
        (_a = fdr_catalogs_order_form_validation_1.OrderCatalogsFormValidationSchema.fields) === null || _a === void 0 ? true : delete _a.recaptchaToken;
    }
    else {
        if (fdr_catalogs_order_form_validation_1.OrderCatalogsFormValidationSchema.fields && recaptchaValidation) {
            fdr_catalogs_order_form_validation_1.OrderCatalogsFormValidationSchema.fields.recaptchaToken = recaptchaValidation;
        }
    }
    return (react_1.default.createElement(formik_1.Formik, { initialValues: {
            salutation: undefined,
            city: '',
            email: '',
            firstName: '',
            lastName: '',
            country: countryOptions[0].value,
            road: '',
            zip: '',
            subscribe: false,
            phone: '',
            recaptchaToken: '',
        }, onSubmit: onSubmit, validationSchema: fdr_catalogs_order_form_validation_1.OrderCatalogsFormValidationSchema }, formik => {
        return (react_1.default.createElement(fdr_catalogs_order_form_styles_1.CatalogForm, { noValidate: true, onSubmit: (e) => formik.handleSubmit(e) },
            react_1.default.createElement(fdr_catalogs_order_form_styles_1.FormContent, null,
                genderInputType == fdr_catalogs_order_form_types_1.IOrderCatalogsFormGenderInputType.Radio && (react_1.default.createElement(fdr_catalogs_order_form_styles_1.RadioInputWrap, null,
                    react_1.default.createElement(fdr_catalogs_order_form_styles_1.ValidatedRadioGroupWrap, { required: true, options: genderRadioOptions, name: 'salutation', label: t('forms:gender.label'), error: formik.errors.salutation
                            ? t(formik.errors.salutation)
                            : null }))),
                genderInputType == fdr_catalogs_order_form_types_1.IOrderCatalogsFormGenderInputType.Select && (react_1.default.createElement(fdr_catalogs_order_form_styles_1.InputWrap, null,
                    react_1.default.createElement(fdr_catalogs_order_form_styles_1.CustomValidatedSelectInput, { required: true, name: "salutation", autoComplete: "country", options: genderSelectOptions, label: t('forms:gender.label'), showErrorMessage: showInlinesErrorMessages }))),
                react_1.default.createElement(fdr_catalogs_order_form_styles_1.InputWrap, null,
                    react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "firstName", label: t('forms:firstName.label'), autoComplete: "given-name", placeholder: t('forms:firstName.placeholder'), showErrorMessage: showInlinesErrorMessages })),
                react_1.default.createElement(fdr_catalogs_order_form_styles_1.InputWrapOdd, null,
                    react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "lastName", label: t('forms:lastName.label'), autoComplete: "family-name", placeholder: t('forms:lastName.placeholder'), showErrorMessage: showInlinesErrorMessages })),
                react_1.default.createElement(fdr_catalogs_order_form_styles_1.InputWrap, null,
                    react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "road", label: t('forms:street.label'), autoComplete: "street-address", placeholder: t('forms:street.placeholder'), showErrorMessage: showInlinesErrorMessages })),
                react_1.default.createElement(fdr_catalogs_order_form_styles_1.InputWrap, null,
                    react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "zip", label: t('forms:zipCode.label'), autoComplete: "postal-code", placeholder: t('forms:zipCode.placeholder'), showErrorMessage: showInlinesErrorMessages })),
                react_1.default.createElement(fdr_catalogs_order_form_styles_1.InputWrap, null,
                    react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "city", label: t('forms:city.label'), autoComplete: "address-level2", placeholder: t('forms:city.placeholder'), showErrorMessage: showInlinesErrorMessages })),
                react_1.default.createElement(fdr_catalogs_order_form_styles_1.InputWrap, null,
                    react_1.default.createElement(fdr_catalogs_order_form_styles_1.CustomValidatedSelectInput, { required: true, name: "country", autoComplete: "country", options: countryOptions, label: t('forms:country.label'), showErrorMessage: showInlinesErrorMessages })),
                react_1.default.createElement(fdr_catalogs_order_form_styles_1.InputWrap, null,
                    react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "email", type: "email", label: t('forms:email.label'), placeholder: t('forms:email.placeholder'), showErrorMessage: showInlinesErrorMessages })),
                react_1.default.createElement(fdr_catalogs_order_form_styles_1.InputWrapOdd, null,
                    react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { name: "phone", type: "tel", label: t('forms:phone.label'), autoComplete: "tel", placeholder: t('forms:phone.placeholder'), showErrorMessage: showInlinesErrorMessages })),
                react_1.default.createElement(fdr_catalogs_order_form_styles_1.CheckboxInputWrap, null,
                    react_1.default.createElement(components_common_checkbox_1.Checkbox, { name: "subscribe", value: formik.values.subscribe ? 'subscribe' : undefined, checked: formik.values.subscribe, content: t('newsletterConfirmation.checkbox'), className: "order-catalogs-checkbox", onChange: (_, e) => formik.handleChange(e) })),
                isCaptchaEnabled && (react_1.default.createElement(fdr_catalogs_order_recaptcha_1.default, { formik: formik }))),
            react_1.default.createElement(fdr_catalogs_order_form_styles_1.SubmitButtonWrapper, null,
                react_1.default.createElement(fdr_catalogs_order_form_styles_1.SubmitOrderModalButton, { type: "submit", icon: submitButtonIcon },
                    isCounterEnabled && react_1.default.createElement(components_common_counter_1.Counter, null, ids.length),
                    t('forms:order.button')))));
    }));
};
exports.default = FdrCatalogsOrderForm;
//# sourceMappingURL=fdr-catalogs-order-form.js.map